import React, { useEffect } from "react";
import { useAuth } from "./auth/AuthProvider";
import { signInWithGoogle } from "./auth/index";
import HomePage from "./pages/HomePage";
import StartPage from "./pages/StartPage";
import LandingPage from "./pages/LandingPage";
import PreviewPage from "./pages/PreviewPage";
import PrivacyPage from "./pages/PrivacyPage";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { analytics, logEvent } from "./firebase";
import ChallengeRegistrationForm from "./registration/ChallengeRegistrationForm";
import AddChallengePage from "./pages/AddChallengePage";
import StatisticsPage from "./pages/StatisticsPage";
import ChallengeDashboard from "./pages/ChallengeDashboard";
import Header from "./components/Header";
import WorkoutsPage from "./pages/WorkoutsPage";
import WorkoutDetailPage from "./pages/WorkoutDetailPage";
import WorkoutSessionPage from "./pages/WorkoutSessionPage";
import AddWorkoutPage from "./pages/AddWorkoutPage";
import LogWorkoutPage from "./pages/LogWorkoutPage";
import GoalsPage from "./pages/GoalsPage";
import GoalDetailPage from "./pages/GoalDetailPage";
import AddGoalPage from "./pages/AddGoalPage";
import LogGoalAttemptPage from "./pages/LogGoalAttemptPage";
import AdminPage from "./pages/AdminPage";

const handleSignIn = async () => {
  await signInWithGoogle();
};

const PageTracker = ({ isAuthenticated }) => {
  const location = useLocation();
  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      section: isAuthenticated ? "app" : "landing",
    });
  }, [location, isAuthenticated]);
  return null;
};

const App = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-gray-600 dark:text-gray-300">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors overflow-x-hidden">
      <Router>
        <PageTracker isAuthenticated={!!user} />
        {user ? (
          <>
            <Header />
            <main className="pt-20 pb-8">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard" element={<StartPage />} />
                <Route path="/challenges" element={<StartPage />} />
                <Route path="/register" element={<ChallengeRegistrationForm />} />
                <Route path="/add-challenge" element={<AddChallengePage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/challenge/:challengeId" element={<ChallengeDashboard />} />
                <Route path="/workouts" element={<WorkoutsPage />} />
                <Route path="/workout/:workoutId" element={<WorkoutDetailPage />} />
                <Route path="/workout-session/:workoutId" element={<WorkoutSessionPage />} />
                <Route path="/add-workout" element={<AddWorkoutPage />} />
                <Route path="/log-workout" element={<LogWorkoutPage />} />
                <Route path="/goals" element={<GoalsPage />} />
                <Route path="/goal/:goalId" element={<GoalDetailPage />} />
                <Route path="/add-goal" element={<AddGoalPage />} />
                <Route path="/log-goal-attempt" element={<LogGoalAttemptPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/profile" element={<StartPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
              </Routes>
            </main>
          </>
        ) : (
          <Routes>
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/preview" element={<PreviewPage />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        )}
      </Router>
    </div>
  );
};

export default App;
